// src/GlobalVue/Treeutils/helpers/handleAddNode.ts

import { Node } from '../types';
import { addChildNodeById } from '../helpers';
import { callNodeCommandApi } from '../api/callNodeCommandApi';
import { callGenerateNodeIdApi } from '../api/callGenerateNodeIdApi';
import { findNodeByIdAndEnrich } from '../helpers';
interface HandleAddNodeParams {
  parentId: string;
  data: Node[];
  setData: React.Dispatch<React.SetStateAction<Node[]>>;
  setEditNodeId: React.Dispatch<React.SetStateAction<string | null>>;
  setNewNodeName: React.Dispatch<React.SetStateAction<string>>;
  setNewlyAddedNodeId: React.Dispatch<React.SetStateAction<string | null>>;
}

export const handleAddNodeLogic = async ({
  parentId,
  data,
  setData,
  setEditNodeId,
  setNewNodeName,
  setNewlyAddedNodeId,
}: HandleAddNodeParams): Promise<void> => {
  // Find parent node to get clientid
  const parentNode = parentId ? findNodeByIdAndEnrich(data, parentId) : null;
  const clientid = parentNode?.originalParentId || ''; // Ensure a fallback

  if (!clientid) {
    console.error('Client ID is missing for the parent node.');
    return;
  }
  console.log("Hola : ", data)
  // Call the backend API to get a new node ID
  const newNodeId = await callGenerateNodeIdApi(parentId);

  if (!newNodeId) {
    console.error('Failed to generate new node ID from server.');
    return;
  }

  const newNode: Node = {
    id: newNodeId,
    name: '',
    children: [],
  };

  const success = await callNodeCommandApi({
    nodeId: newNodeId,
    clientid, // Pass clientid here
    command: 'add',
    data: { parentId },
  });

  if (success) {
    const updatedData = addChildNodeById(data, parentId, newNode);
    setData(updatedData);
    setEditNodeId(newNodeId);
    setNewNodeName('');
    setNewlyAddedNodeId(newNodeId);
  } else {
    console.error('Failed to add node on server.');
  }
};

